import { StoreAction } from "../../@core/constants/action";
import { defaultAutomationFilter } from "../../@core/constants/variables";

const initialState = {
  smsAutomationRulesList: [],
  emailAutomationRulesList: [],
  whatsappAutomationRulesList: [],
  automationFilterData: defaultAutomationFilter,
};
export default function (state = initialState, action) {
  switch (action.type) {
    case StoreAction.GET_EMAIL_AUTOMATION_RULES:
      return { ...state, emailAutomationRulesList: action.payload };
    case StoreAction.GET_SMS_AUTOMATION_RULES:
      return { ...state, smsAutomationRulesList: action.payload };
    case StoreAction.GET_WHATSAPP_AUTOMATION_RULES:
      return { ...state, whatsappAutomationRulesList: action.payload };
    case StoreAction.SET_AUTOMATION_FILTER:
      return { ...state, automationFilterData: action.payload };
    default:
      return state;
  }
}
